import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-red-500"
}

interface Props {
  title: string;
  required?: boolean;
  hasError?: boolean;
  disabled?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FieldLabel',
  props: {
    title: {},
    required: { type: Boolean },
    hasError: { type: Boolean },
    disabled: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass([
    'mb-1 block font-medium',
    props.disabled ? 'text-neutral2-500' : 'text-neutral2-950',
    {'text-red-500':props.hasError}
  ])
  }, [
    _createTextVNode(_toDisplayString(props.title) + " ", 1 /* TEXT */),
    (props.required)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, "*"))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}
}

})